module.exports = __webpack_public_path__ + "static/img/esrb-teen.55d6fe5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/esrb-teen.jpg
// module id = +ou9
// module chunks = 34